module.exports = Jsw.skinUrl + "/images/sticker-collection/sticker/zombie.png?7bfe59ee6bdbff2e372b05761ef891b9";